<template>
  <el-config-provider :locale="elementLocale">
    <div id="app">
      <router-view />
    </div>
  </el-config-provider>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import enLocale from 'element-plus/dist/locale/en.mjs'
import esLocale from 'element-plus/dist/locale/es.mjs'

export default {
  name: 'App',
  setup() {
    const store = useStore()
    
    // 获取Element Plus语言包
    const getElementLocale = (locale) => {
      const localeMap = {
        'zh': zhCn,
        'en': enLocale,
        'es': esLocale
      }
      return localeMap[locale] || zhCn
    }
    
    // 根据当前语言计算Element Plus的locale
    const elementLocale = computed(() => {
      const currentLanguage = store.state.app.language || 'zh'
      return getElementLocale(currentLanguage)
    })
    
    return {
      elementLocale
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

#app {
  height: 100%;
}

.el-button {
  border-radius: 4px;
}

.el-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-input__wrapper {
  border-radius: 4px;
}
</style>